import React from "react";
import { Container } from "./Styled";

type CardProps = {
  children: React.ReactNode;
  className?: string;
};

const Card: React.FunctionComponent<CardProps> = ({ children, className })  => {
  return (
    <Container className={className}>
        {children}
    </Container>
  );
};

export default Card; 